import { css } from '@emotion/react';

import { styleguideColors as COLORS } from '@/Client/Styles/kaiShikiTokens';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { styleguideFontFamily as FONT } from '@kaiizen/kai-shiki/core';

/** Prototype `.tab-empty.is-origin` — Step 1 empty draft origination fork. */
export const ORIGINATION_EMPTY_STATE_STYLE = css`
  label: SCOPE_VIDEO_ORIGINATION_EMPTY_STATE;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 400px;
  padding: 64px 32px;
  text-align: center;
  background: ${COLORS.surfaceMuted};
`;

export const ORIGINATION_EMPTY_ICON_STYLE = css`
  label: SCOPE_VIDEO_ORIGINATION_EMPTY_ICON;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 22px;
  color: ${COLORS.textSecondary};
  background: ${COLORS.sunken};
  border: 1px solid ${COLORS.stroke};
`;

export const ORIGINATION_EMPTY_TITLE_STYLE = css`
  label: SCOPE_VIDEO_ORIGINATION_EMPTY_TITLE;
  margin: 0 0 8px;
  font-family: ${FONT.display};
  font-size: ${pxToRem(20)};
  font-weight: 700;
  letter-spacing: -0.005em;
  line-height: 1.2;
  color: ${COLORS.ink};
`;

export const ORIGINATION_EMPTY_DESC_STYLE = css`
  label: SCOPE_VIDEO_ORIGINATION_EMPTY_DESC;
  max-width: 440px;
  margin: 0 0 22px;
  font-family: ${FONT.body};
  font-size: ${pxToRem(15.5)};
  line-height: 1.5;
  color: ${COLORS.textSecondary};
`;

export const ORIGINATION_EMPTY_CTA_STYLE = css`
  label: SCOPE_VIDEO_ORIGINATION_EMPTY_CTA;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 20px;
  border: 1px solid ${COLORS.ink};
  background: ${COLORS.ink};
  color: ${COLORS.white};
  font-family: ${FONT.mono};
  font-size: ${pxToRem(11)};
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  transition: filter 0.12s;

  &:hover:not(:disabled) {
    filter: brightness(1.2);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    filter: none;
  }
`;

export const ORIGINATION_VIDEO_REQS_STYLE = css`
  label: SCOPE_VIDEO_ORIGINATION_REQS;
  width: 100%;
  max-width: 360px;
  margin-top: 26px;
`;

export const ORIGINATION_VIDEO_REQS_HEADING_STYLE = css`
  label: SCOPE_VIDEO_ORIGINATION_REQS_HEADING;
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: ${COLORS.stroke};
  }

  span {
    font-family: ${FONT.mono};
    font-size: ${pxToRem(10)};
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: ${COLORS.textSecondary};
    white-space: nowrap;
  }
`;

export const ORIGINATION_VIDEO_REQS_LIST_STYLE = css`
  label: SCOPE_VIDEO_ORIGINATION_REQS_LIST;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 10px 0 0;
  padding: 0;
  list-style: none;

  li {
    font-family: ${FONT.body};
    font-size: ${pxToRem(13)};
    line-height: 1.45;
    color: ${COLORS.textSecondary};
  }
`;
